import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'input',
    'placeholder',
    'previews',
    'previewList',
    'count',
    'submit',
    'dropzone',
  ]

  connect() {
    this.files = []
    this.setupDropzone()
  }

  setupDropzone() {
    if (!this.hasDropzoneTarget) return

    this.dropzoneTarget.addEventListener('dragover', (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.add('border-primary')
    })

    this.dropzoneTarget.addEventListener('dragleave', (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.remove('border-primary')
    })

    this.dropzoneTarget.addEventListener('drop', (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.remove('border-primary')
      const files = Array.from(e.dataTransfer.files).filter(
        (f) => f.type.startsWith('image/') || this.isHeic(f)
      )
      this.addFiles(files)
    })
  }

  isHeic(file) {
    return (
      file.type === 'image/heic' ||
      file.type === 'image/heif' ||
      file.name.toLowerCase().endsWith('.heic') ||
      file.name.toLowerCase().endsWith('.heif')
    )
  }

  preview(event) {
    const files = Array.from(event.target.files)
    this.addFiles(files)
  }

  addFiles(files) {
    this.files = [...this.files, ...files]
    this.updatePreview()
  }

  updatePreview() {
    if (this.files.length === 0) {
      this.placeholderTarget.classList.remove('d-none')
      this.previewsTarget.classList.add('d-none')
      this.submitTarget.disabled = true
      return
    }

    this.placeholderTarget.classList.add('d-none')
    this.previewsTarget.classList.remove('d-none')
    this.countTarget.textContent = this.files.length
    this.submitTarget.disabled = false

    this.previewListTarget.innerHTML = ''
    this.files.forEach((file, index) => {
      const div = document.createElement('div')
      div.className = 'position-relative'

      if (this.isHeic(file)) {
        div.innerHTML = `
          <div class="rounded border bg-light d-flex flex-column align-items-center justify-content-center" style="width: 80px; height: 80px;">
            <i class="bi bi-image text-muted fs-4"></i>
            <small class="text-muted" style="font-size: 0.6rem;">HEIC</small>
          </div>
        `
      } else {
        const reader = new FileReader()
        reader.onload = (e) => {
          div.innerHTML = `
            <img src="${e.target.result}" class="rounded border" style="width: 80px; height: 80px; object-fit: cover;">
            <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle p-0" style="width: 20px; height: 20px; line-height: 1;" data-index="${index}" data-action="click->bulk-upload#removeFile">
              <i class="bi bi-x"></i>
            </button>
          `
        }
        reader.readAsDataURL(file)
      }

      this.previewListTarget.appendChild(div)
    })
  }

  removeFile(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.index)
    this.files.splice(index, 1)
    this.updatePreview()
  }

  validateAndSubmit(event) {
    if (this.files.length === 0) {
      event.preventDefault()
      return
    }

    const dataTransfer = new DataTransfer()
    this.files.forEach((file) => dataTransfer.items.add(file))
    this.inputTarget.files = dataTransfer.files
  }
}
